import { useMemo } from 'react';

import { CONTACT_LIMIT_NUMBER, DEFAULT_CONTACT_LIMIT_NUMBER } from '@hero/constants';
import { useGetMerchant } from '@hero/services/merchant-service/hooks';
import {
  useGetRecognitionAcceptanceRate,
  useGetRecognitionRecipientList
} from '@hero/services/order-service';

function useMaxContactHasError({ recognitionCode, recognition, contacts }) {
  const { data: merchantData } = useGetMerchant({ options: { includeConfigs: true } });
  const { data: recognitionAcceptanceRate } = useGetRecognitionAcceptanceRate({
    recognitionCode
  });
  const { data: recognitionRecipients } = useGetRecognitionRecipientList(
    {
      code: recognitionCode
    },
    {
      enabled: !!recognitionCode
    }
  );

  const contactNumberLimit =
    merchantData?.configs[CONTACT_LIMIT_NUMBER] ?? DEFAULT_CONTACT_LIMIT_NUMBER;

  const totalRecipients = useMemo(() => {
    return recognitionRecipients?.totalDocs || 0;
  }, [recognitionRecipients]);

  const maxContactHasError = useMemo(() => {
    if (contacts?.type === 'list') {
      return (
        totalRecipients === 0 ||
        recognitionAcceptanceRate?.acceptanceRates?.accepted > totalRecipients ||
        totalRecipients > contactNumberLimit
      );
    }

    return (
      contacts?.maxCount == 0 ||
      recognitionAcceptanceRate?.acceptanceRates?.accepted > contacts?.maxCount ||
      contacts?.maxCount > contactNumberLimit
    );
  }, [
    merchantData,
    recognition?.settings?.recipientVerification,
    totalRecipients,
    contacts,
    recognitionAcceptanceRate
  ]);
  return maxContactHasError;
}

export { useMaxContactHasError };
